import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OptionComponent } from './option.component';

@NgModule({
  imports: [CommonModule],
  declarations: [OptionComponent],
  exports: [CommonModule]
})
export class OptionModule {}
